import { useEffect, useCallback, useRef } from "react";
import { getToken, onMessage, isSupported } from "firebase/messaging";
import { messaging } from "../config/firebase";
import { useUser } from "../contexts/UserContext";
import { SavePushToken } from "../config/api";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export const useNotifications = () => {
  const { user } = useUser();
  const registered = useRef(false);

  const registerToken = useCallback(async () => {
    if (!user || !VAPID_KEY || registered.current) return;

    registered.current = true;

    try {
      const supported = await isSupported();
      if (!supported) return;

      // Si déjà refusé, on ne peut pas redemander — l'utilisateur doit le faire manuellement
      if (Notification.permission === "denied") return;

      const permission = await Notification.requestPermission();
      if (permission !== "granted") return;

      const fcmToken = await getToken(messaging, { vapidKey: VAPID_KEY });
      if (!fcmToken) return;

      await SavePushToken({ user: user.code, tokenValue: fcmToken }, user.access_token);
    } catch (error) {
      registered.current = false;
      console.error("Erreur enregistrement notifications:", error);
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;

    registerToken();

    // Affiche une notification quand l'app est au premier plan
    const unsubscribe = onMessage(messaging, (payload) => {
      if (Notification.permission !== "granted" || !payload.notification) return;
      new Notification(payload.notification.title || "Dalal", {
        body: payload.notification.body,
        icon: "/dalalicon192.png",
      });
    });

    return unsubscribe;
  }, [user, registerToken]);
};
